window.initAssessorResourcesForm = function() {
  tinyMceFull();

  $(".js-resource-type").on('change', function(){
    $('[data-type]').addClass('is-hidden');
    $(`[data-type="${$(this).val()}"]`).removeClass('is-hidden');
  })
}
